import { Dispatch, SetStateAction } from "react";
import { SelectedOrder } from "../OrderPage.types";

export enum Action {
  CANCEL = "cancel",
  SUCCESSFUL_SAVE = "successfulSave",
  RESIZE_WINDOW = "resizeWindow",
  TRANSACT_RESPONSE = "transactResponse",
}

export enum ResponseCode {
  APPROVED = "1",
  DECLINED = "2",
  ERROR = "3",
  HELD_FOR_REVIEW = "4",
}

export type TransactionResponse = {
  accountNumber: string;
  accountType: string;
  authorization: string;
  billTo: {
    address: string;
    city: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    state: string;
    zip: string;
  };
  dateTime: string;
  responseCode: string;
  totalAmount: string;
  transId: string;
};

export type ActionType = {
  action: Action | null;
  postTransactionData?: TransactionResponse;
  height?: string;
  width?: string;
};

declare global {
  interface Window {
    CommunicationHandler: {
      onReceiveCommunication?: (queryStr: string) => void;
      onmessage?: (queryStr: string) => void;
    };
  }
}

export type PaymentModalProps = {
  modalPayloadState: [
    SelectedOrder | null,
    Dispatch<SetStateAction<SelectedOrder | null>>
  ];
  onPaymentSuccess: (response: TransactionResponse) => void;
};
